var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconText(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22,5v2H2v-2H22Zm-8,4H2v2H14v-2ZM2,15H19v-2H2v2Zm0,4h15v-2H2v2Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconText);
export default __webpack_public_path__ + "static/1762842647/media/icon-text.3d85d29845c261a5c9ec4bba91ba8947.svg";
export { ForwardRef as ReactComponent };